import { render, staticRenderFns } from "./report_profit_detail.vue?vue&type=template&id=6310dd56&scoped=true"
import script from "./report_profit_detail.vue?vue&type=script&lang=js"
export * from "./report_profit_detail.vue?vue&type=script&lang=js"
import style0 from "./report_profit_detail.vue?vue&type=style&index=0&id=6310dd56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6310dd56",
  null
  
)

export default component.exports